import { getComposeStore } from 'owa-calendar-compose-store-manager';
import updateRecurrenceOnStartDateChange from 'owa-recurrence-utils/lib/updateRecurrenceOnStartDateChange';
import { onDateTimesChanged, setRecurrence } from 'owa-calendar-compose-form-actions';
import { orchestrator } from 'satcheljs';

/**
 * When the start date is updated, update the recurrence
 */
export default orchestrator(onDateTimesChanged, ({ datesSelected }) => {
    const store = getComposeStore();
    if (!store || !store.event || !store.event.Recurrence) {
        return;
    }

    setRecurrence(updateRecurrenceOnStartDateChange(datesSelected.start, store.event.Recurrence));
});
